import { render, staticRenderFns } from "./SubmitFinance.vue?vue&type=template&id=74b45b72&scoped=true"
import script from "./SubmitFinance.vue?vue&type=script&lang=js"
export * from "./SubmitFinance.vue?vue&type=script&lang=js"
import style0 from "./SubmitFinance.vue?vue&type=style&index=0&id=74b45b72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b45b72",
  null
  
)

export default component.exports